import React from 'react'
import logo from './logos/Google.png'

function GoogleLogo({
  className
}) {
  return (
    <div className={className}>
      <img src={logo} alt="Google Logo"/>
    </div>
    )
  }

export default GoogleLogo
